var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:_vm.fixUpdate,staticClass:"my-2 d-flex justify-content-center"},[(_vm.item.custom_name != _vm.item.new_custom_name)?_c('b-button',{staticClass:"btn btn-save",attrs:{"size":"sm"},on:{"click":_vm.saveCategory}},[_c('b-icon',{attrs:{"icon":"check-square"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }